<template>
  <Popover>
    <PopoverTrigger as-child>
      <Button
        variant="outline"
        class="w-full justify-start text-left font-normal"
        :class="!modelValue && 'text-muted-foreground'"
      >
        <CalendarDays class="mr-2 h-4 w-4" />
        {{ modelValue ? format(modelValue, 'PPP') : 'Pick a date' }}
      </Button>
    </PopoverTrigger>
    <PopoverContent class="w-auto p-0">
      <Calendar
        v-model="calendarValue"
        :disabled="disabled"
      />
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts">
import { CalendarDays } from 'lucide-vue-next'
import { format } from 'date-fns'
import { Button } from '../button'
import { Calendar } from '../calendar'
import { Popover, PopoverContent, PopoverTrigger } from '../popover'
import { parseDate, type DateValue } from '@internationalized/date'
import { computed } from 'vue'

const props = defineProps<{
  modelValue?: Date
  disabled?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: Date | undefined]
}>()

// Convert Date to DateValue for the Calendar component
const calendarValue = computed({
  get: () => props.modelValue ? parseDate(props.modelValue.toISOString().split('T')[0]) : undefined,
  set: (value: DateValue | undefined) => {
    emit('update:modelValue', value ? new Date(value.toString()) : undefined)
  }
})
</script> 